import { IModule } from 'redux-dynamic-modules';
import { onboardingSlice } from './onboarding.slice';
import { ONBOARDING_SLICE_NAME, OnboardingOwnState } from './onboarding.types';

export const getOnboardingModule = (): IModule<OnboardingOwnState> => ({
  id: onboardingSlice.name,
  reducerMap: {
    [ONBOARDING_SLICE_NAME]: onboardingSlice.reducer,
  },
  retained: true,
});
